










































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import draggable from 'vuedraggable';
import {
  CplusCriteria,
  UpdateCriteriaPayload,
} from '@/store/modules/projects/types/projects.types';
import { cloneDeep as _cloneDeep, orderBy as _orderBy } from 'lodash';
import AuditCriteriaCreateModal from '@/views/Project/components/AuditCriteriaCreateModal.vue';
import CriteriaGuideModal from '@/components/CriteriaGuideModal.vue';
import {
  BooleanCriterionContent,
  CheckboxesCriterionContent,
  CheckboxesSingleCriterionContent,
  Criterion,
  CRITERION_TYPE,
  RangeCriterionContent,
  ContinuousDiscreteCriterionContent,
} from '@/store/types/criterions.types';
import {
  isDifferentDeep,
  isTruthy,
} from '@/jbi-shared/util/watcher.vue-decorator';
import JbiCriteriaUpdateModal from '../../../views/Project/components/JbiCriteriaUpdateModal.vue';
import { Action, namespace, State } from 'vuex-class';
import { ToastProgrammatic as Toast } from 'buefy';
import { ApiState } from '../../../store/types/general.types';
import { UpdateSingleCriteriaPayload } from '@/store/modules/audits/types/audits.types';
import { RootState } from '@/store/store';
import InfoModal from '@/components/InfoModal.vue';
import DeleteModalBox from '@/components/DeleteModalBox.vue';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    BaseModal,
    draggable,
    AuditCriteriaCreateModal,
    CriteriaGuideModal,
    InfoModal,
    DeleteModalBox,
  },
  data: () => {
    return {
      CRITERION_TYPE, // Keep this for backwards compatibility and for non-class components
    };
  },
})
export default class AuditCriteriaList extends Vue {
  // IMPORTANT: This class property declaration is required for TypeScript class components
  // to properly access CRITERION_TYPE in the template. The data() option with arrow function
  // can cause scope issues. This dual declaration ensures it works in all contexts.
  public CRITERION_TYPE = CRITERION_TYPE;

  @Prop()
  public selectedCriteriaArray!: CplusCriteria[];
  @Prop({ default: null })
  public projectId!: number;
  @Prop({ default: null })
  public auditId!: number;
  @Prop({ default: false })
  public createProject!: boolean;
  @Prop({ default: false })
  public isProject!: boolean;
  @Prop({
    default() {
      return false;
    },
  })
  public projectEdit!: boolean;
  @Prop({ default: true })
  public editable!: boolean;
  @Prop({ type: Boolean, default: false })
  public isAuditCycleCommencedOrCompleted!: boolean;

  public reOrderedCriteriaArray: CplusCriteria[] = [];
  public drag = false;
  public guideTooltipLabel = 'Add, edit, or delete a guide for this criteria';
  public removedCriteriaIndex = -1;

  public editingCriteriaIndex: number | null = null; // To know which item is being edited for overlay
  public criterionForEdit: CplusCriteria | null = null; // Data for the modal
  public isEditModalActive: boolean = false; // Controls modal visibility/state for our logic
  public isEditModalMinimized: boolean = false; // Controls minimized state for our logic
  private editModalKey: number = 0; // To help re-render modal if needed

  public dragOptions = {
    animation: 200,
    group: 'description',
    disabled: !this.editable,
    ghostClass: 'draggable__ghost',
    chosenClass: 'draggable__chosen',
    dragClass: 'draggable__drag',
    forceFallback: false, // it cause weird drag behaviour when set it to true
  };

  @unsavedChangesGuard.State('userSelectedKeepEditing')
  public userSelectedKeepEditing!: boolean;

  @unsavedChangesGuard.Action('resetKeepEditingFlag')
  public resetKeepEditingFlag!: () => void;

  @Action('projects/getProjectCriteria')
  public getProjectCriteria!: (projectId: number) => void;

  @Action('audits/getAuditCriteria')
  public getAuditCriteria!: (auditId: number) => void;

  @Action('projects/updateProjectCriteriaById')
  public updateProjectCriteriaById!: (payload: UpdateCriteriaPayload) => void;

  @State((state) => state.projects.apiState.updateProjectCriteriaById)
  public updateProjectCriteriaByIdState!: ApiState;

  @Action('projects/deleteProjectCriteriaById')
  public deleteProjectCriteriaById!: (payload: {
    projectId: number;
    criteriaId: number;
  }) => void;

  @State((state) => state.projects.apiState.deleteProjectCriteriaById)
  public deleteProjectCriteriaByIdState!: ApiState;

  @Action('audits/updateAuditCriteriaById')
  public updateAuditCriteriaById!: (
    payload: UpdateSingleCriteriaPayload,
  ) => void;

  @State((state) => state.audits.apiState.updateAuditCriteriaById)
  public updateAuditCriteriaByIdState!: ApiState;

  @Action('audits/deleteAuditCriteriaById')
  public deleteAuditCriteriaById!: (payload: {
    auditId: number;
    criteriaId: number;
  }) => void;

  @State((state: RootState) => state.audits.apiState.deleteAuditCriteriaById)
  public deleteAuditCriteriaByIdState!: ApiState;

  @Action('projects/getUpdatedJBICriteriaWithAcknowledgement')
  public getUpdatedJBICriteriaWithAcknowledgement!: (projectId: number) => void;

  // Sorts by order and id to ensure consistent rendering
  get selectedCriteriaList() {
    return this.selectedCriteriaArray;
  }

  public deleteModal(confirmButtonText: string, modalContent: string): void {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Remove criteria?',
        modalContent,
        confirmButtonText,
      },
      events: {
        confirm: () => {
          const criteria: CplusCriteria = this.reOrderedCriteriaArray[
            this.removedCriteriaIndex
          ];
          if (criteria.criteriaDetails) {
            if (this.isProject) {
              this.deleteProjectCriteriaById({
                projectId: this.projectId,
                criteriaId: criteria.criteriaDetails.id,
              });
            } else {
              this.deleteAuditCriteriaById({
                auditId: this.auditId,
                criteriaId: criteria.criteriaDetails.id,
              });
            }
          } else {
            this.emitChanges();
          }
        },
      },
    });
  }

  public infoModal(confirmButtonText: string, modalContent: string): void {
    const Modal = this.$buefy.modal.open({
      parent: this,
      component: InfoModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Cannot remove criteria',
        modalContent,
        confirmButtonText,
      },
      events: {
        confirm: () => {
          Modal.close();
        },
        close: () => {
          Modal.close();
        },
      },
    });
  }

  public removeCriteria(index: number) {
    const criteria: CplusCriteria = this.reOrderedCriteriaArray[index];
    const isCriteriaAddedIntoAuditCycles = Boolean(
      criteria.auditCycles && criteria.auditCycles.length,
    );
    this.removedCriteriaIndex = index;
    let confirmationButtonText = 'Remove';
    let confirmationText = `<p>Are you sure you want to remove this Criterion?<p>`;

    if (this.isProject) {
      confirmationText = `<p>Removing this criterion will also result in its removal from the upcoming Data Collection Period(s). Are you sure you want to remove this Criterion?<p>`;

      if (isCriteriaAddedIntoAuditCycles) {
        let AffectedAuditCycleNames = '';
        criteria.auditCycles.forEach((auditCycle: string) => {
          AffectedAuditCycleNames += `<li>${auditCycle}</li>`;
        });

        confirmationButtonText = 'Ok';
        confirmationText = `
        <p>This is the only criteria in the upcoming data collection periods. Please add another criteria before removing it.</p>
        <p style="margin-top: 12px;"><b>Affected data collection periods:</b></p>
        <ul style="list-style: disc; padding: 0.25rem 1rem; max-height: 100px; overflow: scroll;">
          ${AffectedAuditCycleNames}
        </ul>`;
      }
    }

    if (isCriteriaAddedIntoAuditCycles) {
      this.infoModal(confirmationButtonText, confirmationText);
    } else {
      this.deleteModal(confirmationButtonText, confirmationText);
    }
  }

  public mounted() {
    this.reOrderedCriteriaArray = _cloneDeep(this.selectedCriteriaList);
  }

  public getRangeValue(type: string, criteria: any): string {
    const config =
      this.createProject && Object.keys(criteria).includes('config')
        ? criteria.config
        : criteria.criteriaDetails && criteria.criteriaDetails.config
        ? criteria.criteriaDetails.config
        : null;

    const configArray = typeof config === 'string' ? config.split(',') : config;
    if (type === 'min') {
      return configArray[0];
    } else {
      return configArray[1];
    }
  }

  public isContinuousDiscreteRangeEnabled(criteria: any): boolean {
    const config =
      this.createProject && Object.keys(criteria).includes('config')
        ? criteria.config
        : criteria.criteriaDetails && criteria.criteriaDetails.config
        ? criteria.criteriaDetails.config
        : null;

    return config ? true : false;
  }

  /**
   * Open AuditCriteriaCreateModal.
   * This modal is used to add new criteria and also edit existing criteria.
   */
  public openCriteriaAddModal() {
    this.$buefy.modal.open({
      parent: this,
      component: AuditCriteriaCreateModal,
      hasModalCard: true,
      trapFocus: true,
      customClass: 'transparent-modal-background',
      props: {
        modalTitle: 'Add New Criteria',
        reOrderedCriteriaArray: this.reOrderedCriteriaArray,
        isProject: this.isProject,
        projectId: this.projectId,
        auditId: this.auditId,
      },
      events: {
        updateReOrderedCriteriaArray: (newValue: any) => {
          this.reOrderedCriteriaArray = newValue;
          this.$emit(
            'update:selectedCriteriaArray',
            this.reOrderedCriteriaArray,
          );
        },
      },
    });
  }

  public openCriteriaGuideModal(
    criteria: CplusCriteria,
    criteriaIndex: number,
  ) {
    this.$buefy.modal.open({
      parent: this,
      component: CriteriaGuideModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        currentCriteria: criteria,
        criteriaIndex,
        projectId: this.projectId,
        auditId: this.auditId,
        createProject: this.createProject,
      },
      events: {
        updateCriteriaGuide: (newValue: any) => {
          this.reOrderedCriteriaArray[criteriaIndex] = newValue;
          this.$emit(
            'update:selectedCriteriaArray',
            this.reOrderedCriteriaArray,
          );
        },
      },
    });
  }

  public openCriteriaEditModal(criteria: CplusCriteria, criteriaIndex: number) {
    let criterion: Criterion;
    if (criteria.type === CRITERION_TYPE.BOOLEAN) {
      criterion = new Criterion({
        content: new BooleanCriterionContent({
          title: criteria.title,
          type: CRITERION_TYPE.BOOLEAN,
          booleanOptions: criteria.booleanOptions,
          sourceLink: criteria.sourceLink,
        }),
      });
    } else if (criteria.type === CRITERION_TYPE.RANGE) {
      criterion = new Criterion({
        content: new RangeCriterionContent({
          title: criteria.title,
          type: CRITERION_TYPE.RANGE,
          range: criteria.range,
          sourceLink:
            criteria.sourceLink !== undefined ? criteria.sourceLink : '',
        }),
      });
    } else if (criteria.type === CRITERION_TYPE.CHECKBOXES_SINGLE) {
      criterion = new Criterion({
        content: new CheckboxesSingleCriterionContent({
          title: criteria.title,
          type: CRITERION_TYPE.CHECKBOXES_SINGLE,
          checkboxesOptions: criteria.checkboxesOptions,
          sourceLink:
            criteria.sourceLink !== undefined ? criteria.sourceLink : '',
        }),
      });
    } else if (criteria.type === CRITERION_TYPE.CHECKBOXES) {
      criterion = new Criterion({
        content: new CheckboxesCriterionContent({
          title: criteria.title,
          type: CRITERION_TYPE.CHECKBOXES,
          checkboxesOptions: criteria.checkboxesOptions,
          sourceLink:
            criteria.sourceLink !== undefined ? criteria.sourceLink : '',
        }),
      });
    } else {
      const criteriaConfig = criteria.config
        ? criteria.config
        : criteria.criteriaDetails && criteria.criteriaDetails.config
        ? criteria.criteriaDetails.config
        : null;

      const config =
        typeof criteriaConfig === typeof 'string'
          ? criteriaConfig.split(', ')
          : criteriaConfig;
      criterion = new Criterion({
        content: new ContinuousDiscreteCriterionContent({
          title: criteria.title,
          type: CRITERION_TYPE.CONTINUOUS_DISCRETE,
          config,
          sourceLink:
            criteria.sourceLink !== undefined ? criteria.sourceLink : '',
        }),
      });
    }

    this.criterionForEdit = { ...criteria, content: criterion.content };
    this.editingCriteriaIndex = criteriaIndex;
    this.isEditModalMinimized = false; // Ensure it's not minimized on open
    this.isEditModalActive = true;
  }

  public handleCloseModal(): void {
    this.isEditModalActive = false;
    this.isEditModalMinimized = false;
    this.criterionForEdit = null;
    this.editingCriteriaIndex = null;
    this.editModalKey += 1; // Force re-mount of modal component to reset its internal state
  }

  public handleMinimizeModal(): void {
    this.isEditModalMinimized = true;
  }

  public handleRestoreModal(): void {
    this.isEditModalMinimized = false;
  }

  public handleCriteriaReorder(event: any) {
    this.reOrderedCriteriaArray.forEach((criteria, index) => {
      criteria.order = index + 1;
    });
    this.$emit('update:selectedCriteriaArray', this.reOrderedCriteriaArray);
  }

  public handleUpdateReOrderedCriteriaArray(newValue: any) {
    this.reOrderedCriteriaArray = newValue;
    this.$emit('update:selectedCriteriaArray', this.reOrderedCriteriaArray);
    this.$emit('updateCriteriaHandler');
    // Close the modal after the update is emitted
    this.handleCloseModal();
  }

  public handleUpdateCriteria(payload: {
    projectId?: number;
    newValue: CplusCriteria;
    applyChanges: boolean;
    selectedAuditIds: number[];
  }): void {
    const { newValue, applyChanges, selectedAuditIds } = payload;
    if (this.isProject) {
      this.updateProjectCriteriaById({
        projectId: this.projectId,
        criteria: newValue,
        selectedAuditIds: selectedAuditIds,
      });
    } else {
      this.updateAuditCriteriaById({
        currentAuditId: this.auditId,
        selectedAuditIds: [...new Set([...selectedAuditIds, this.auditId])],
        criteria: newValue,
      });
    }
    // Close the modal after the update is emitted
    this.handleCloseModal();
  }

  @Watch('selectedCriteriaArray')
  @isTruthy
  @isDifferentDeep
  public watchSelectedCriteriaArray() {
    this.reOrderedCriteriaArray = _cloneDeep(this.selectedCriteriaList);
  }

  public getTags(tagInfo: any) {
    if (Array.isArray(tagInfo)) {
      return tagInfo;
    } else {
      const tags: string[] = [];
      if (tagInfo) {
        Object.keys(tagInfo).forEach((key: string) => {
          const tag = tagInfo[key];
          tag.forEach((value: string) => {
            tags.push(value);
          });
        });
      }
      return tags;
    }
  }

  criteriaUpdatedToast() {
    Toast.open({
      message: `Criteria successfully updated.`,
      position: 'is-top',
      type: 'is-dark',
      duration: 3500,
    });
  }

  criteriaDeletedToast() {
    Toast.open({
      message: `Criteria successfully deleted.`,
      position: 'is-top',
      type: 'is-dark',
      duration: 3500,
    });
  }

  @Watch('updateProjectCriteriaByIdState.success')
  @isTruthy
  public watchUpdateProjectCriteriaByIdState() {
    this.getProjectCriteria(this.projectId);
    this.getUpdatedJBICriteriaWithAcknowledgement(this.projectId);
    this.criteriaUpdatedToast();
  }

  @Watch('updateAuditCriteriaByIdState.success')
  @isTruthy
  public watchUpdateAuditCriteriaByIdState(): void {
    this.getAuditCriteria(this.auditId);
    this.criteriaUpdatedToast();
  }

  @Watch('deleteProjectCriteriaByIdState.success')
  @isTruthy
  public watchDeleteProjectCriteriaByIdState() {
    this.getProjectCriteria(this.projectId);
    this.emitChanges();
    this.criteriaDeletedToast();
  }

  @Watch('deleteAuditCriteriaByIdState.success')
  @isTruthy
  public watchDeleteAuditCriteriaByIdState() {
    this.getAuditCriteria(this.auditId);
    this.emitChanges();
    this.criteriaDeletedToast();
  }

  public emitChanges() {
    if (this.removedCriteriaIndex > -1) {
      this.$emit(
        'updateDeletedCriteriaList',
        this.reOrderedCriteriaArray[this.removedCriteriaIndex],
      );
      this.reOrderedCriteriaArray.splice(this.removedCriteriaIndex, 1);
      this.$emit('update:selectedCriteriaArray', this.reOrderedCriteriaArray);
    }
  }

  @Watch('userSelectedKeepEditing')
  public onUserSelectedKeepEditing(newValue: boolean): void {
    if (newValue && this.isEditModalActive && this.isEditModalMinimized) {
      this.handleRestoreModal();
    }
    // Always reset the flag after checking it
    this.resetKeepEditingFlag();
  }

  public openJbiCriteriaUpdateModal(criteria: CplusCriteria): void {
    this.$buefy.modal.open({
      parent: this,
      component: JbiCriteriaUpdateModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        criteria,
      },
    });
  }

  // get isAuditEligibleForEdit(): boolean {
  //   return this.isProject
  // }
}
